import script from "./FeedbackSuccessModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeedbackSuccessModal.vue?vue&type=script&setup=true&lang=ts"

import "./FeedbackSuccessModal.vue?vue&type=style&index=0&id=c1619d5a&scoped=true&lang=css"
import "./FeedbackSuccessModal.vue?vue&type=style&index=1&id=c1619d5a&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1619d5a"]])

export default __exports__